export const signCertificateErrors = {
    "1": "Hub settings are not configured properly. Please correct invalid settings and try again.",
    "2": "The file submitted was empty or null. Please select a valid file.",
    "3": "An internal server error has occurred while generating the signed certificate. Please try again.",
    "4": "The file submitted does not have valid certificate signing request content. Please choose a different file.",
    "5": "Unable to generate a signed certificate due to an invalid date range.",
    "6": "Unable to generate a signed certificate due to an invalid issuer certificate.",
    "7": "Unable to generate a signed certificate due to insufficient permissions.",
    "8": "An unknown error has occurred while generating the signed certificate. Please try again.",
    "OPCERTERR0001": "Hub settings are not configured properly. Please correct invalid settings and try again.",
    "OPCERTERR0002": "The file submitted was empty or null. Please select a valid file.",
    "OPCERTERR0003": "An internal server error has occurred while generating the signed certificate. Please try again.",
    "OPCERTERR0004": "The file submitted does not have valid certificate signing request content. Please choose a different file.",
    "OPCERTERR0005": "Unable to generate a signed certificate due to an invalid date range.",
    "OPCERTERR0006": "Unable to generate a signed certificate due to an invalid issuer certificate.",
    "OPCERTERR0007": "Unable to generate a signed certificate due to insufficient permissions.",
    "OPCERTERR0008": "An unknown error has occurred while generating the signed certificate. Please try again.",
    "EntryRequired": "An entry is required",
    "InvalidPort":"Invalid Port",
    "InValidRangePort": "Valid Range of Port number is from 1 to 65534",
}
export const userAccessPermission = {
    None: 0,
    View: 1,
    Edit: 2,
    Override: 3,
    ResetPassword: 4,
    Full: 5,
    Create: 20,
    Delete: 21,
    CreateOrDelete: 22,
    Acknowledge: 23,
    InsertComments: 24,
    EditAlarmRouting: 25,
    ConfigureAlarmRecipients: 26,
    ApplyOrCancelExceptions: 27,
    CreateOrEditExceptions: 28,
    ApplyOrCancelSnowDay: 29,
    AdvancedOverrides: 30,
    IgnoreAlarms: 31,
    CriticalPoint: 34,
};

export const isEmptyErrorValues = (data) => {
    return Object.values(data).filter(x => x !== '').length ? false : true;
}
